<template>

    <div class="card mb-3" v-if="show ">
        <div class="card-body border border-success">
            <div class="row">
                <div class="col-12 medium-text">

                    <p class="ticket-priceGuarantee-title text-success"> <strong>{{__('messages.free_cancellation')}}    </strong> </p>

                    {{__('messages.you_may')}} <strong>{{__('messages.cancel_free')}}</strong> {{__('messages.reservation_until')}} <span class="promo-text">{{data.cancellation.untilDateCancellation | date(__('formaters.cancellation'))}}</span>

                    <button type="button" id="_modal_cancellation" class="btnTertiary" @click="openaModalCancellation()">{{__('messages.more_information')}}</button>
                </div>
            </div>
        </div>

        <cancellation-modal :cancellation="data"></cancellation-modal>

    </div>


</template>

<script>
    import CancellationModal from '../modals/CancellationModal'

    export default {
        props: ['cancellation'],
        data() {
            return {
                data: {},
                show: false
            };
        },
        async mounted() {
            this.data = this.cancellation.find(item => item.cancellation.isCancellationFree);
            this.show = !!this.data; 

        },
        methods: {
            openaModalCancellation() {
                $("#modal-cancellation").modal("show")
            }
        },
        components: {
            CancellationModal,
        }
    }
</script>
